/** @format */

import Tippy from "@tippyjs/react";
import "tippy.js/themes/light.css";
import "../SCSS/Styles.css";
import { ActionKind } from "../../../SupplierView/SupplierViewPropsTypes";
import { EnumSurveyAnswerStatus } from "../../../Common/Enums/EnumsTypes";
import { customFormCompTypes } from "../CustomFormType";
import images from "../../../ImageVariables";

function CustomForm({
  dispatch,
  isPreview,
  surveyAnswersInfo,
  questionId,
  surveyAnswers,
}: customFormCompTypes) {
  return (
    <div className="custom-form-container">
      <div className="file-attachment-cover">
        <div className="file-attachment">
          <div className="download-image">
            <img src={images.download} />
          </div>
          <button
            className="file-attachment-gray"
            onClick={() =>
              dispatch({
                type: ActionKind.OPEN_FILE_UPLOAD_MODAL,
                payload: {
                  toggleState: true,
                  questionId: questionId,
                },
              })
            }
            disabled={
              isPreview ||
              surveyAnswersInfo.surveyStatus ===
                EnumSurveyAnswerStatus?.COMPLETED ||
              surveyAnswers?.[questionId]?.notApplicableInfo?.isNotApplicable
            }
          >
            Download Template{" "}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CustomForm;
